export default __webpack_public_path__ + "static/media/I16.5c3cc39a.jpg";